import { useDocumentVisibility } from '@vueuse/core'
import { watch } from 'vue'

type Options = {
  once: boolean
}

export const useOnTabActivated = (
  fn: () => void,
  option: Options = { once: false }
) => {
  const visibility = useDocumentVisibility()
  const onActivateTabHandler = (_visibility: DocumentVisibilityState) => {
    if (_visibility !== 'visible') {
      return
    }
    if (option.once) {
      unwatch()
    }
    fn()
  }
  const unwatch = watch(visibility, onActivateTabHandler)
  onActivateTabHandler(visibility.value)
}
